import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBadge from "components/MDBadge";

import DataTable from "examples/Tables/DataTable";

import MDActionConfigurator from "components/MDActionConfigurator";

import { createNewAddon, addonUpdating } from "actions/addonActions";
import { getProfile } from "actions/userActions";

function AddonSection({ productSingle }) {
  const configuratorRef = useRef(null);
  const dispatch = useDispatch();
  const [currentState, setCurrentState] = useState("");
  const [currentData, setCurrentData] = useState({
    _id: "",
    addonName: "",
    description: "",
    product: productSingle?._id,
    addonAmount: 0,
    active: true,
  });

  const getMe = useSelector((state) => state.getMe);
  const { me } = getMe;

  useEffect(() => {
    // if (me?.length === 0) {
    dispatch(getProfile());
    // }
  }, [dispatch]);

  const handleToggleBackdrop = (item, state) => {
    setCurrentData(item);
    setCurrentState(state);
    if (configuratorRef.current) {
      configuratorRef.current.handleToggleConfigurator();
    }
  };

  const handleSubmitAddon = (e) => {
    if (currentState === "edit") {
      dispatch(addonUpdating(currentData?._id, e));
    } else {
      dispatch(createNewAddon(e));
    }
    handleToggleBackdrop({}, "");
  };

  function renderAddonRows(data) {
    const values = [];
    data?.forEach((item, index) => {
      const newElement = {
        name: (
          <MDTypography
            key={index}
            variant="caption"
            color="text"
            fontWeight="medium"
          >
            {item?.addonName}
          </MDTypography>
        ),
        description: (
          <MDBox maxWidth={300}>
            <MDTypography variant="caption" color="text" fontWeight="medium">
              {item?.description}
            </MDTypography>
          </MDBox>
        ),
        addonAmount: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            Ksh. {item?.addonAmount}
          </MDTypography>
        ),
        active: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {item?.active ? (
              <MDBox ml={-1}>
                <MDBadge
                  badgeContent="active"
                  color="dark"
                  variant="gradient"
                  size="sm"
                />
              </MDBox>
            ) : (
              <MDBox ml={-1}>
                <MDBadge
                  badgeContent="inactive"
                  color="success"
                  variant="gradient"
                  size="sm"
                />
              </MDBox>
            )}
          </MDTypography>
        ),
        action: (
          <>
            {(me?.role === "super_admin" || me?.role === "admin") && (
              <MDTypography
                component="a"
                href="#"
                variant="caption"
                color="text"
                fontWeight="medium"
                onClick={() => handleToggleBackdrop(item, "edit")}
              >
                Edit
              </MDTypography>
            )}
          </>
        ),
      };
      values.push(newElement);
    });
    return values;
  }

  return (
    <MDBox>
      <MDBox>
        <MDTypography variant="h6">Addons</MDTypography>
      </MDBox>
      <MDBox p={2} mt="auto">
        {(me?.role === "super_admin" || me?.role === "admin") && (
          <MDButton
            component="a"
            href="#"
            rel="noreferrer"
            variant="gradient"
            color="info"
            onClick={() =>
              handleToggleBackdrop(
                {
                  _id: "",
                  addonName: "",
                  description: "",
                  product: productSingle?._id,
                  addonAmount: 0,
                  active: true,
                },
                ""
              )
            }
          >
            <Icon sx={{ fontWeight: "bold" }}>add</Icon>
            &nbsp;New Addon{" "}
            {productSingle?.productNumber &&
              ` for ${productSingle?.productName} - ${productSingle?.productNumber}`}
          </MDButton>
        )}
      </MDBox>
      <MDBox p={3} mb={5}>
        <DataTable
          table={{
            columns: [
              {
                Header: "Addon Name",
                accessor: "name",
                width: "30%",
                align: "left",
              },
              {
                Header: "Description",
                accessor: "description",
                width: "30%",
                align: "left",
              },
              {
                Header: "Addon Amount",
                accessor: "addonAmount",
                width: "20%",
                align: "center",
              },
              {
                Header: "Active",
                accessor: "active",
                width: "10%",
                align: "center",
              },
              {
                Header: "action",
                accessor: "action",
                width: "10%",
                align: "center",
              },
            ],

            rows: renderAddonRows(productSingle?.addons),
          }}
          isSorted={false}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder
        />
      </MDBox>

      <MDActionConfigurator
        ref={configuratorRef}
        title={`${productSingle?.productName} - ${productSingle?.productNumber}'s Addons Config`}
        onCompleteConfig={handleSubmitAddon}
        data={[
          {
            keyType: "_id",
            valueType: currentData?._id,
          },
          {
            labelType: "Selected Product",
            placeholderType: "Selected Product",
            dataType: "disabled",
            keyType: "product",
            valueType: productSingle?._id,
          },
          {
            labelType: "Addon Name",
            placeholderType: "Enter Addon Name",
            dataType: "text",
            keyType: "addonName",
            valueType: currentData?.addonName,
          },
          {
            labelType: "Description",
            placeholderType: "Enter Description",
            dataType: "text",
            keyType: "description",
            valueType: currentData?.description,
          },
          {
            labelType: "Addon Amount",
            placeholderType: "Enter Addon Amount",
            dataType: "number",
            keyType: "addonAmount",
            valueType: currentData?.addonAmount,
          },
          {
            labelType: "Active",
            placeholderType: "Active",
            dataType: "active",
            keyType: "active",
            valueType: currentData?.active,
          },
        ]}
        state={currentState}
      />
    </MDBox>
  );
}

export default AddonSection;
